/**
 * Performance Plugin Landing Page
 */

import './performance-plugin.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';
import '../shared/mega-menu.js';

// Import landing page modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';

// Import FAQ accordion
import '../shared/faq.js';

console.log('Performance Plugin page loaded (Edge/Vite bundle)');
